"use strict";

module.exports = {
  baseUrl: "https://api.deepai.org",
  //baseUrl: "http://localhost:8000" // for dev
};
